import React, { memo } from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import ROUTES from "router/routes.constants";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "store/slices/user.slice";

const ProtectedRoute = memo(({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  
  if (isAuthenticated) {
    return children;
  }
  
  return <Navigate to={ROUTES.LOGIN} replace />;
});

ProtectedRoute.displayName = 'ProtectedRoute';

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

const PublicRoute = memo(({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  
  if (isAuthenticated) {
    return <Navigate to={ROUTES.EXPLORE} replace />;
  }
  
  return children;
});

PublicRoute.displayName = 'PublicRoute';

PublicRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export { ProtectedRoute, PublicRoute };